import styled from "styled-components";

export const ConfirmationText = styled.div`
  margin: 8px 0px 12px;
  font-size: 18px;
  color: #282828;
`;

export const CreditWarning = styled.span`
  color: #e20000;

  &:hover {
    cursor: pointer;
  }
`;
